module.exports = __webpack_public_path__ + "img/kitchen.5dfba404.jpg";